import { Component } from 'preact';
import style from './styles/SummaryStep.scss';
import DateService from '../../../services/DateService';
import CurrencyService from '../../../services/CurrencyService';
import { connect } from 'react-redux';
import { BackButton, ContinueButton } from '../../form/Buttons';
import { goToCustomerStepAction } from '../../../actions/RegistrationFormActions';
import { bindActionCreators } from 'redux';
import RegistrationRepository from '../../../repositories/RegistrationRepository';
import { withRouter } from 'react-router-dom';
import { CLIENT } from '../../../parameters';
import Countries, { EU_COUNTRIES } from '../../../enums/Countries';
import LoadingSpinner from '../../spinner/LoadingSpinner';
import Captcha from './captcha';
import { FS } from '../../../enums/FeatureSwitch';
import FeatureSwitchService from '../../../services/FeatureSwitchService';

/**
 * @property {Raffle} props.raffle
 * @property {RegistrationFormFields} props.data
 * @property {Function} props.submitReservationAction
 */
@withRouter
class SummaryStep extends Component {
	state = {
		captchaToken: null
	};

	/**
	 * @this SummaryStep
	 */
	submitStep = () => {
		const { data, registrationId } = this.props;
		const { captchaToken } = this.state;

		const consentReducer = (filtered, key) => {
			if (data.consents[key].value) {
				filtered.push(key);
			}
			return filtered;
		};

		const country = data.country.value;
		const city = country === Countries.ROMANIA.value ? data.romanianCity.value : data.city.value;
		const { sizeId } = this.props.match.params;

		this.props.submitReservationAction(
			this.props.raffle,
			{
				id: registrationId,
				sizerunId: sizeId,
				account: data.account.value,
				email: data.email.value,
				phone: data.phone.value,
				gender: data.gender.value,
				firstName: data.firstName.value,
				lastName: data.lastName.value,
				instagramUsername: data.instagramUsername.value,
				birthday: this.formatBirthday(data.birthday),
				deliveryAddress: {
					country,
					state: data.usState.value || data.caState.value || '',
					county: data.romanianCounty.value,
					city,
					street: data.streetName.value,
					houseNumber: data.houseNumber.value,
					additional: data.additional.value,
					postalCode: data.postalCode.value
				},
				consents: Object.keys(data.consents).reduce(consentReducer, []),
				verification: {
					token: captchaToken
				}
			},
			this.props.deliveryService
		);
	};

	handleVerifyCaptcha = (token) => {
		this.setState({ captchaToken: token });
	};

	handleExpireCaptcha = () => {
		this.setState({ captchaToken: null });
	};

	handleErrorCaptcha = (error) => {
		this.setState({ captchaToken: null });

		console.error(error);
	};

	/**
	 * @param {Object} birthday
	 * @return {string}
	 */
	formatBirthday(birthday) {
		if (isNaN(birthday.year) || isNaN(birthday.month) || isNaN(birthday.day)) {
			return '';
		}

		return `${birthday.year}-${birthday.month.padLeft(2)}-${birthday.day.padLeft(2)}`;
	}

	componentDidMount() {
		if (CLIENT) {
			window.scrollTo(0, 0);
		}
	}

	render() {
		const { data, raffle, deliveryService, submittingRegistration, goToCustomerStepAction, disabledCaptcha } = this.props;

		// If we were redirected to summary step by the landing page, raffle might still be loading..
		// Also, it could theoretically happen (very unlikely) that no delivery service was found for selected country..
		if (!raffle || !deliveryService) {
			return (
				<div className="abs-vertical-center text-center">
					<LoadingSpinner active />
				</div>
			);
		}
		const currencyCode = CurrencyService.getCurrencyCode();
		const price = raffle.getPrice(currencyCode) + deliveryService.price;
		const countryOption = data.country.options.find(option => option.value === data.country.value);
		const hasDutyAlert = !EU_COUNTRIES.includes(data.country.value);
		const { captchaToken } = this.state;

		return (
			<div className={`row form-style ${style['summary-step']}`}>
				<div className={`col-12 ${style.topic}`}>
					<h3 className={style.title}>Contact and delivery</h3>
					<InfoRow title="Name:" value={`${data.firstName.value} ${data.lastName.value}`} />
					<InfoRow title="Instagram username:" value={data.instagramUsername.value} />
					<InfoRow title="Birthday:" value={this.formatBirthday(data.birthday)} />
					<div className={style['spacer-20']} />
					<InfoRow title="E-mail:" value={data.email.value} />
					<InfoRow title="Phone number:" value={data.phone.value} />
					<div className={style['spacer-30']} />
					<InfoRow title="Street name:" value={data.streetName.value} />
					<InfoRow title="House number:" value={data.houseNumber.value} />
					<InfoRow title="Additional:" value={data.additional.value} />
					<InfoRow title="Postal code:" value={data.postalCode.value} />
					{ countryOption.value === Countries.ROMANIA.value
						? ([
							<InfoRow title="City:" value={data.romanianCity.value} />,
							<InfoRow title="County:" value={data.romanianCounty.value} />
						])
						: <InfoRow title="City:" value={data.city.value} />
					}
					{ countryOption.value === Countries.USA.value
						? <InfoRow title="State:" value={data.usState.value} />
						: null
					}
					{ countryOption.value === Countries.CANADA.value
						? <InfoRow title="State:" value={data.caState.value} />
						: null
					}
					<InfoRow title="Country:" value={countryOption ? countryOption.label : ''} />
				</div>
				<div className={`col-12 ${style.topic}`}>
					<h3 className={style.title}>Shipping</h3>
					<InfoRow title="Delivery cost:" value={CurrencyService.format(deliveryService.price)} />
				</div>
				<div className={`col-12 ${style.topic}`}>
					<h3 className={style.title}>Payment</h3>
					<InfoRow title="Total price:" value={CurrencyService.format(price)} />
					{hasDutyAlert && (
						<div className={`alert alert-warning ${style.alert}`}>
							If your delivery country charges customs or import duties, you will have to pay these charges. Unfortunately, we have no control over them and cannot inform you of what they will be. Customs policies vary from country to country so if you have any questions, please contact your local customs office for more info.
						</div>
					)}
				</div>
				<div className={`col-12 ${style.topic}`}>
					<h3 className={style.title}>Raffle</h3>
					<InfoRow title="Registration ends:" value={DateService.getHumanizedDate(raffle.getCloseRegistrationAtAsDate(), true)} />
					<InfoRow title="Results:" value={DateService.getHumanizedDate(raffle.getResultsAtAsDate(), true)} />
				</div>
				<div className={`col-12 ${style.topic}`}>
					<Captcha
						onVerify={this.handleVerifyCaptcha}
						onExpire={this.handleExpireCaptcha}
						onError={this.handleErrorCaptcha}
					/>
				</div>
				<ContinueButton
					enabledMessage={'Confirm your order'}
					disabled={!captchaToken && !disabledCaptcha}
					spinner={submittingRegistration}
					onClick={this.submitStep}
				/>
				<BackButton
					className="my-3"
					onClick={goToCustomerStepAction}
				/>
			</div>
		);
	}
}

const InfoRow = ({ title, value }) => (
	<div className="row">
		<div className={`col-6 ${style.key}`}>{title}</div>
		<div className={`col-6 ${style.value}`}>{value}</div>
	</div>
);

const mapStateToProps = (state) => {
	const { fields, raffle, deliveryService, registration, submittingRegistration } = state.raffleForm;

	return {
		raffle,
		registrationId: registration ? registration.id : null,
		deliveryService,
		data: /** @type RegistrationFormFields */ {
			account: fields.account,
			email: fields.email,
			phone: fields.phone,
			gender: fields.gender,
			firstName: fields.firstName,
			lastName: fields.lastName,
			instagramUsername: fields.instagramUsername,
			birthday: fields.birthday,
			usState: fields.usState,
			caState: fields.caState,
			romanianCounty: fields.romanianCounty,
			romanianCity: fields.romanianCity,
			streetName: fields.streetName,
			houseNumber: fields.houseNumber,
			additional: fields.additional,
			postalCode: fields.postalCode,
			city: fields.city,
			country: fields.country,
			consents: fields.consents
		},
		submittingRegistration,
		disabledCaptcha: FeatureSwitchService.has(state.featureSwitch, FS.DISABLE_CAPTCHA, raffle.id)
	};
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
	goToCustomerStepAction,
	submitReservationAction: RegistrationRepository.submitReservation
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SummaryStep);



// WEBPACK FOOTER //
// ./components/blocks/raffleForm/SummaryStep.js